import React from 'react';

import InputVoicebotAudioText from './InputVoicebotAudioText';

import { voiceItems } from '../content';

const CommonInputSquare = ({ item, updateItemWithDebounce }) => {
  const handleInputChange = (event) => {
    const { value } = event.target;

    updateItemWithDebounce({
      voiceSettings: {
        ...item.voiceSettings,
        deScriptTts: value,
      },
    });
  };

  return (
    <div className="square__voice-bot">
      <div className="square__voice-bot__wrapper-img">
        <img
          src={`/assets/images/icons/${voiceItems[item?.type]?.icon}.svg`}
          alt=""
        />
        <span>{voiceItems[item?.type]?.title}</span>
      </div>

      <InputVoicebotAudioText
        value={item?.voiceSettings?.deScriptTts}
        onChange={handleInputChange}
        id={`input-voicebot-square-${item?._id}`}
      />
    </div>
  );
};

export default CommonInputSquare;
